module.exports = __webpack_public_path__ + "media/ven/bghead-d8385f37.png";